import * as React from "react";
function SvgSketch({ title, titleId, ...props }) {
    return (React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 35 35", fill: "none", xmlns: "http://www.w3.org/2000/svg", "aria-labelledby": titleId, ...props },
        title ? React.createElement("title", { id: titleId }, title) : null,
        React.createElement("circle", { cx: 17.5, cy: 17.5, r: 17.5, fill: "#000" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.525 23.319v4.156h4.157L23.94 15.217l-4.156-4.156L7.525 23.319zm19.629-11.316a1.104 1.104 0 000-1.563l-2.593-2.594a1.104 1.104 0 00-1.563 0l-2.029 2.029 4.157 4.156 2.028-2.028z", fill: "#F2F3F4" })));
}
const MemoSvgSketch = React.memo(SvgSketch);
export default MemoSvgSketch;
